import { memo } from 'react';

import isEqual from 'fast-deep-equal';

import type { TotalProps } from './types/total.props';

import { useTotalConfiguration } from './hooks/total-configuration.hook';

import cssClasses from './total.module.css';

/**
 * Displays the total pagination information using the provided props and configuration hook.
 *
 * @param props - The properties required to render the total pagination information.
 * @returns A React element displaying the total pagination text.
 *
 * @remarks
 * This component is memoized using `React.memo` with a deep equality check (`fast-deep-equal`)
 * to prevent unnecessary re-renders when the props have not changed.
 *
 * @see {@link useTotalConfiguration} for how the display text is generated.
 */
function Total(props: TotalProps) {
  return <div className={cssClasses.pageOf}>{useTotalConfiguration(props)}</div>;
}

export default memo(Total, (prev, next) => {
  return isEqual(prev, next);
}) as typeof Total;
